import categoriesJSON from '@requests/mocks/categories.json';

export const CONCERTS_SLUGS = [
  'rock-pop',
  'alternative-rock',
  'dance-electronic',
  'country-folk',
  'rap-hip-hop',
  'hard-rock-metal',
];

export const SPRING_TRAINING_SLUGS = ['mlb-spring-training'];

// Base set of known league/category slugs for event pages
const STATIC_LEAGUE_SLUGS = [
  // Major leagues
  'mlb',
  'nba',
  'nfl',
  'nhl',
  'mls',
  'mls-major-league-soccer',
  // NCAA
  'ncaa-mens-football',
  'ncaa-mens-basketball',
  // Other sports
  'pga',
  'formula-1',
  'nascar',
  'ufc',
  'tennis',
  'pro-bowl',
  'world-cup',
  'pwhl',
  'rodeo',
  'cfl',
  'wwe',
  'wnba',
  'independent-league-baseball',
  // Concerts
  ...CONCERTS_SLUGS,
  // Spring Training
  ...SPRING_TRAINING_SLUGS,
];

// Slugs provided by the categories feed/mock
const CATEGORY_SLUGS = categoriesJSON.categories.map(({ slug }) =>
  slug.toLowerCase()
);

// All valid league/category slugs for event pages
export const VALID_LEAGUE_SLUGS = Array.from(
  new Set([...STATIC_LEAGUE_SLUGS, ...CATEGORY_SLUGS, ...SPRING_TRAINING_SLUGS])
);

/**
 * Validates if a league slug is a valid event page slug.
 * Returns false for numeric IDs or invalid slugs.
 * Allows any properly formatted slug (letters, numbers, hyphens).
 */
export const isValidLeagueSlug = (slug: string): boolean => {
  const normalized = (slug || '').toLowerCase().trim();

  // Reject empty, purely numeric (like event IDs), or slugs without letters
  if (
    !normalized ||
    /^\d+$/.test(normalized) ||
    !/[a-z]/.test(normalized) ||
    !/^[a-z0-9-]+$/.test(normalized)
  ) {
    return false;
  }

  // Allow any valid slug format - no longer restricted to whitelist
  return true;
};

export const formatConcertTitle = (key) => {
  const items = {
    'rock-pop': 'Pop',
    'alternative-rock': 'Alternative Rock',
    'dance-electronic': 'Dance/Electronic',
    'country-folk': 'Country & Folk',
    'rap-hip-hop': 'Rap & Hip-Hop',
    'hard-rock-metal': 'Hard Rock/Metal',
  };

  return items[key] ?? key;
};

export const formatSpringTrainingTitle = (key) => {
  const items = {
    'mlb-spring-training': 'MLB Spring Training',
  };

  return items[key] ?? key;
};

export const transformLeagueForAPI = (leagueSlug: string) => {
  const ticketEvolutionLeagueSlugs: Record<string, string> = {
    'premier-league': 'english-premier-league',
    'serie-a': 'italian-serie-a',
  };

  if (ticketEvolutionLeagueSlugs[leagueSlug]) {
    return ticketEvolutionLeagueSlugs[leagueSlug];
  }

  if (SPRING_TRAINING_SLUGS.includes(leagueSlug)) {
    return 'mlb';
  }

  return leagueSlug;
};
